import { useEffect } from "react";

export function useAutoRefresh(load, intervalMs = 30000) {
  useEffect(() => {
    load();
    const t = setInterval(load, intervalMs);
    const onVisible = () => { if (document.visibilityState === "visible") load(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", load);
    window.addEventListener("online", load);
    return () => {
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", load);
      window.removeEventListener("online", load);
    };
  }, [load, intervalMs]);
}
